type Props = {
  style?: React.CSSProperties;
  className?: string;
};

interface JandiSymbolProps extends Props {
  alt?: boolean;
}

export function JandiLogo({ style, className }: Props) {
  return (
    <svg
      style={style}
      className={className}
      width="155"
      height="59"
      viewBox="0 0 155 59"
      fill="none"
    >
      <path
        d="M0.6203 57.2696V48.928C1.53553 49.1616 2.86678 49.2784 3.94842 49.2784C6.29475 49.2784 7.84233 47.7268 7.84233 45.4913V15.0612H18.6255V46.6925C18.6255 53.5993 14.2157 58.3039 7.72585 58.3039C5.37952 58.3039 2.56725 57.9035 0.6203 57.2696ZM7.16007 5.90214C7.16007 2.44872 9.73936 0.0296631 13.2339 0.0296631C16.795 0.0296631 19.3077 2.44872 19.3077 5.90214C19.3077 9.35555 16.7783 11.8247 13.2339 11.8247C9.73936 11.8247 7.16007 9.35555 7.16007 5.90214Z"
        fill="#4285F4"
      />
      <path
        d="M21.5542 29.9092C21.5542 20.4832 26.8293 14.3271 34.6337 14.3271C38.927 14.3271 41.6228 16.2791 43.7528 19.5657H44.3186V15.0779H55.0518V44.7405H44.3186V40.3696H43.7528C41.6394 43.7062 38.9437 45.4913 34.6337 45.4913C26.7128 45.4913 21.5542 39.452 21.5542 29.9092ZM44.2687 29.9092C44.2687 26.1221 41.8058 23.3527 38.3113 23.3527C34.8168 23.3527 32.354 26.1055 32.354 29.9092C32.354 33.6963 34.8168 36.4657 38.3113 36.4657C41.8058 36.4657 44.2687 33.6963 44.2687 29.9092Z"
        fill="#4285F4"
      />
      <path
        d="M58.9956 15.0612H69.7288V19.4322H70.2946C72.6409 15.9788 75.1204 14.3772 78.6149 14.3772C84.7553 14.3772 89.0486 19.3821 89.0486 26.2222V44.7406H78.332V28.2409C78.332 25.3714 76.7345 23.4195 74.2051 23.4195C71.6758 23.4195 69.7288 25.4882 69.7288 28.4244V44.7406H58.9956V15.0612Z"
        fill="#4285F4"
      />
      <path
        d="M91.4116 29.9092C91.4116 20.4832 96.7532 14.3272 104.491 14.3272C108.269 14.3272 111.147 15.8286 113.094 18.5313H113.66V1.84814H124.393V44.7406H113.66V41.2871H113.094C111.147 43.9898 108.385 45.4913 104.541 45.4913C96.6866 45.4913 91.4116 39.452 91.4116 29.9092ZM114.109 29.9092C114.109 26.1722 111.597 23.3527 108.152 23.3527C104.658 23.3527 102.195 26.1722 102.195 29.9092C102.195 33.6463 104.658 36.4657 108.152 36.4657C111.597 36.4657 114.109 33.6463 114.109 29.9092Z"
        fill="#4285F4"
      />
      <path
        d="M127.721 5.90214C127.721 2.44872 130.301 0.0296631 133.795 0.0296631C137.406 0.0296631 139.936 2.4654 139.936 5.91882C139.936 9.37223 137.406 11.808 133.795 11.808C130.301 11.8247 127.721 9.35555 127.721 5.90214ZM128.454 15.0612H139.187V44.7405H128.454V15.0612Z"
        fill="#4285F4"
      />
      <path
        d="M142.615 39.4854C142.615 36.1654 145.011 33.8298 148.489 33.8298C151.967 33.8298 154.363 36.132 154.363 39.4854C154.363 42.8387 151.967 45.1743 148.489 45.1743C145.028 45.1743 142.615 42.822 142.615 39.4854ZM153.065 39.4854C153.065 36.8661 151.201 34.9976 148.506 34.9976C145.81 34.9976 143.946 36.8661 143.946 39.4854C143.946 42.138 145.81 44.0065 148.506 44.0065C151.201 44.0065 153.065 42.138 153.065 39.4854ZM146.009 36.1487H149.055C150.419 36.1487 151.401 36.9829 151.401 38.1674C151.401 39.2018 150.602 39.9859 149.521 40.0693L149.437 40.086L151.318 42.7052H149.67L148.056 40.2194H147.391V42.7052H146.009V36.1487ZM148.855 39.2017C149.521 39.2017 149.987 38.8014 149.987 38.2008C149.987 37.6168 149.487 37.2165 148.855 37.2165H147.391V39.2017H148.855Z"
        fill="#4285F4"
      />
    </svg>
  );
}



export function JandiLogoWhite({ style, className }: Props) {
  return (
    <svg
      style={style}
      className={className}
      width="155"
      height="59"
      viewBox="0 0 155 59"
      fill="none"
    >
      <path
        d="M0.6203 57.2696V48.928C1.53553 49.1616 2.86678 49.2784 3.94842 49.2784C6.29475 49.2784 7.84233 47.7268 7.84233 45.4913V15.0612H18.6255V46.6925C18.6255 53.5993 14.2157 58.3039 7.72585 58.3039C5.37952 58.3039 2.56725 57.9035 0.6203 57.2696ZM7.16007 5.90214C7.16007 2.44872 9.73936 0.0296631 13.2339 0.0296631C16.795 0.0296631 19.3077 2.44872 19.3077 5.90214C19.3077 9.35555 16.7783 11.8247 13.2339 11.8247C9.73936 11.8247 7.16007 9.35555 7.16007 5.90214Z"
        fill="#ffffff"
      />
      <path
        d="M21.5542 29.9092C21.5542 20.4832 26.8293 14.3271 34.6337 14.3271C38.927 14.3271 41.6228 16.2791 43.7528 19.5657H44.3186V15.0779H55.0518V44.7405H44.3186V40.3696H43.7528C41.6394 43.7062 38.9437 45.4913 34.6337 45.4913C26.7128 45.4913 21.5542 39.452 21.5542 29.9092ZM44.2687 29.9092C44.2687 26.1221 41.8058 23.3527 38.3113 23.3527C34.8168 23.3527 32.354 26.1055 32.354 29.9092C32.354 33.6963 34.8168 36.4657 38.3113 36.4657C41.8058 36.4657 44.2687 33.6963 44.2687 29.9092Z"
        fill="#ffffff"
      />
      <path
        d="M58.9956 15.0612H69.7288V19.4322H70.2946C72.6409 15.9788 75.1204 14.3772 78.6149 14.3772C84.7553 14.3772 89.0486 19.3821 89.0486 26.2222V44.7406H78.332V28.2409C78.332 25.3714 76.7345 23.4195 74.2051 23.4195C71.6758 23.4195 69.7288 25.4882 69.7288 28.4244V44.7406H58.9956V15.0612Z"
        fill="#ffffff"
      />
      <path
        d="M91.4116 29.9092C91.4116 20.4832 96.7532 14.3272 104.491 14.3272C108.269 14.3272 111.147 15.8286 113.094 18.5313H113.66V1.84814H124.393V44.7406H113.66V41.2871H113.094C111.147 43.9898 108.385 45.4913 104.541 45.4913C96.6866 45.4913 91.4116 39.452 91.4116 29.9092ZM114.109 29.9092C114.109 26.1722 111.597 23.3527 108.152 23.3527C104.658 23.3527 102.195 26.1722 102.195 29.9092C102.195 33.6463 104.658 36.4657 108.152 36.4657C111.597 36.4657 114.109 33.6463 114.109 29.9092Z"
        fill="#ffffff"
      />
      <path
        d="M127.721 5.90214C127.721 2.44872 130.301 0.0296631 133.795 0.0296631C137.406 0.0296631 139.936 2.4654 139.936 5.91882C139.936 9.37223 137.406 11.808 133.795 11.808C130.301 11.8247 127.721 9.35555 127.721 5.90214ZM128.454 15.0612H139.187V44.7405H128.454V15.0612Z"
        fill="#ffffff"
      />
      <path
        d="M142.615 39.4854C142.615 36.1654 145.011 33.8298 148.489 33.8298C151.967 33.8298 154.363 36.132 154.363 39.4854C154.363 42.8387 151.967 45.1743 148.489 45.1743C145.028 45.1743 142.615 42.822 142.615 39.4854ZM153.065 39.4854C153.065 36.8661 151.201 34.9976 148.506 34.9976C145.81 34.9976 143.946 36.8661 143.946 39.4854C143.946 42.138 145.81 44.0065 148.506 44.0065C151.201 44.0065 153.065 42.138 153.065 39.4854ZM146.009 36.1487H149.055C150.419 36.1487 151.401 36.9829 151.401 38.1674C151.401 39.2018 150.602 39.9859 149.521 40.0693L149.437 40.086L151.318 42.7052H149.67L148.056 40.2194H147.391V42.7052H146.009V36.1487ZM148.855 39.2017C149.521 39.2017 149.987 38.8014 149.987 38.2008C149.987 37.6168 149.487 37.2165 148.855 37.2165H147.391V39.2017H148.855Z"
        fill="#ffffff"
      />
    </svg>
  );
}
export function JandiSymbol({
  style,
  className,
  alt = false,
}: JandiSymbolProps) {
  const pathFill = alt ? "#4285F4" : "white";
  const bgFill = alt ? "white" : "#4285F4";
  return (
    <svg
      style={style}
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <g clipPath="url(#clip0_120_351)">
        <path
          d="M17 34C7.61016 34 0 26.3898 0 17C0 7.61016 7.61016 0 17 0C26.3898 0 34 7.61016 34 17C34 26.3898 26.3898 34 17 34Z"
          fill={bgFill}
        />
        <path
          d="M12.0011 15.4541H8.90918V26.273H12.0011V15.4541Z"
          fill={pathFill}
        />
        <path
          d="M26.5971 10.8189H24.3658V7.72704C24.3658 6.80532 23.5637 6.08814 22.6499 6.19173L8.91178 7.72704L8.90381 13.9081H29.001V13.2202C29.001 11.8947 27.9252 10.8189 26.5971 10.8189Z"
          fill={pathFill}
        />
        <path
          d="M24.7297 15.4541H21.2739L23.5928 20.0892H21.2739C21.2739 22.3125 20.408 23.1811 18.182 23.1811H16.6361V26.273H18.182C22.1106 26.273 24.3631 24.0205 24.3631 20.0919H27.046L24.7297 15.4541Z"
          fill={pathFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_120_351">
          <rect width="34" height="34" fill={bgFill} />
        </clipPath>
      </defs>
    </svg>
  );
}

